import { render, staticRenderFns } from "./gender_bar.vue?vue&type=template&id=a34de88e&"
import script from "./gender_bar.vue?vue&type=script&lang=js&"
export * from "./gender_bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports